import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LauraChat from '../../components/StoreClub/LauraChat';

const LocalCheck: React.FC = () => {
  const navigate = useNavigate();
  const [showNotLocal, setShowNotLocal] = useState(false);

  if (showNotLocal) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <img src="/rbf-logo.png" alt="Red Bridge Farm" style={styles.logo} />
          <h1 style={styles.title}>Store Club</h1>
        </div>

        <LauraChat message="No worries! While our Store Club is for local customers, you can still get our great non-GMO feeds at retailers across Washington!" />

        <div style={styles.content}>
          <div style={styles.card}>
            <div style={styles.cardIcon}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#508590" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <h2 style={styles.cardTitle}>Find Our Products Near You</h2>
            <p style={styles.cardText}>
              Red Bridge Farm feeds are available at farm stores and retailers throughout Washington state.
            </p>
            <a
              href="https://redbridgefeed.com/pages/find-a-store"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.primaryButton}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: '0.5rem' }}>
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              Find a Store Near You
            </a>
          </div>

          <div style={styles.divider}>
            <span style={styles.dividerLine}></span>
            <span style={styles.dividerText}>or</span>
            <span style={styles.dividerLine}></span>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#508590" strokeWidth="2">
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
              </svg>
            </div>
            <h2 style={styles.cardTitle}>Shop Online</h2>
            <p style={styles.cardText}>
              Browse our full selection and shop online at redbridgefeed.com
            </p>
            <a
              href="https://redbridgefeed.com"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.secondaryButton}
            >
              Visit redbridgefeed.com
            </a>
          </div>

          <button
            style={styles.backLink}
            onClick={() => setShowNotLocal(false)}
          >
            &larr; Actually, I am local to Kettle Falls
          </button>
        </div>

        <div style={styles.footer}>
          <p style={styles.footerText}>Red Bridge Farm Feed Co. &bull; Kettle Falls, WA</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <img src="/rbf-logo.png" alt="Red Bridge Farm" style={styles.logo} />
        <h1 style={styles.title}>Store Club</h1>
      </div>

      <LauraChat message="Welcome! Before we get started, I have a quick question for you." />

      <div style={styles.content}>
        <div style={styles.questionCard}>
          <div style={styles.locationIcon}>
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#E73C3E" strokeWidth="1.5">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </div>

          <h2 style={styles.questionTitle}>Are you local to the Kettle Falls, WA area?</h2>
          <p style={styles.questionSubtext}>
            Our Store Club is designed for customers who shop at our Kettle Falls store location.
          </p>

          <div style={styles.buttonGroup}>
            <button
              style={styles.yesButton}
              onClick={() => navigate('/club/register')}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: '0.5rem' }}>
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Yes, I'm Local
            </button>

            <button
              style={styles.noButton}
              onClick={() => setShowNotLocal(true)}
            >
              No, I'm Not Local
            </button>
          </div>
        </div>

        <div style={styles.alreadyMember}>
          <p style={styles.alreadyMemberText}>Already a Store Club member?</p>
          <button
            style={styles.signInLink}
            onClick={() => navigate('/club/login')}
          >
            Sign In Here
          </button>
        </div>
      </div>

      <div style={styles.footer}>
        <p style={styles.footerText}>Red Bridge Farm Feed Co. &bull; Kettle Falls, WA</p>
        <p style={styles.footerSubtext}>NON-GMO, SOY & CORN-FREE FEEDS</p>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f8f9fa',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    borderBottom: '1px solid #e0e0e0',
  },
  logo: {
    width: '50px',
    height: 'auto',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#E73C3E',
    margin: 0,
    fontFamily: "'Open Sans', sans-serif",
  },
  content: {
    flex: 1,
    padding: '1.5rem',
    maxWidth: '500px',
    margin: '0 auto',
    width: '100%',
    boxSizing: 'border-box',
  },
  questionCard: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '2rem',
    textAlign: 'center',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  locationIcon: {
    marginBottom: '1rem',
  },
  questionTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#333',
    margin: '0 0 0.75rem 0',
    fontFamily: "'Open Sans', sans-serif",
  },
  questionSubtext: {
    fontSize: '1rem',
    color: '#666',
    margin: '0 0 1.5rem 0',
    lineHeight: '1.5',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  yesButton: {
    backgroundColor: '#2D5A27',
    color: '#fff',
    border: 'none',
    padding: '1rem 1.5rem',
    borderRadius: '10px',
    fontSize: '1.125rem',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
    fontFamily: "'Open Sans', sans-serif",
  },
  noButton: {
    backgroundColor: '#f5f5f5',
    color: '#666',
    border: '2px solid #e0e0e0',
    padding: '1rem 1.5rem',
    borderRadius: '10px',
    fontSize: '1rem',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontFamily: "'Open Sans', sans-serif",
  },
  alreadyMember: {
    marginTop: '2rem',
    textAlign: 'center',
  },
  alreadyMemberText: {
    fontSize: '0.9rem',
    color: '#666',
    margin: '0 0 0.5rem 0',
  },
  signInLink: {
    background: 'none',
    border: 'none',
    color: '#508590',
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
    textDecoration: 'underline',
    fontFamily: "'Open Sans', sans-serif",
  },
  footer: {
    padding: '1.5rem',
    textAlign: 'center',
    borderTop: '1px solid #e0e0e0',
    backgroundColor: '#fff',
  },
  footerText: {
    margin: 0,
    color: '#666',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  footerSubtext: {
    margin: '0.25rem 0 0 0',
    color: '#999',
    fontSize: '0.75rem',
    letterSpacing: '0.5px',
  },
  // Not local view styles
  card: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '1.5rem',
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  cardIcon: {
    marginBottom: '0.75rem',
  },
  cardTitle: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#333',
    margin: '0 0 0.5rem 0',
    fontFamily: "'Open Sans', sans-serif",
  },
  cardText: {
    fontSize: '0.9rem',
    color: '#666',
    margin: '0 0 1.25rem 0',
    lineHeight: '1.5',
  },
  primaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E73C3E',
    color: '#fff',
    border: 'none',
    padding: '1rem 1.5rem',
    borderRadius: '10px',
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background-color 0.2s',
    fontFamily: "'Open Sans', sans-serif",
    width: '100%',
    boxSizing: 'border-box',
  },
  secondaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#508590',
    color: '#fff',
    border: 'none',
    padding: '1rem 1.5rem',
    borderRadius: '10px',
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background-color 0.2s',
    fontFamily: "'Open Sans', sans-serif",
    width: '100%',
    boxSizing: 'border-box',
  },
  divider: {
    display: 'flex',
    alignItems: 'center',
    margin: '1.5rem 0',
  },
  dividerLine: {
    flex: 1,
    height: '1px',
    backgroundColor: '#e0e0e0',
  },
  dividerText: {
    padding: '0 1rem',
    color: '#999',
    fontSize: '0.875rem',
  },
  backLink: {
    background: 'none',
    border: 'none',
    color: '#508590',
    fontSize: '0.9rem',
    cursor: 'pointer',
    marginTop: '1.5rem',
    display: 'block',
    width: '100%',
    textAlign: 'center',
    fontFamily: "'Open Sans', sans-serif",
  },
};

export default LocalCheck;
